// NOTE: 라우터는 경로 조각(*_SEGMENT)을, 이동·비교하는 코드는 조각으로 만든 전체 경로(*_PATH)를 씁니다.
// 조각은 영문 소문자와 - 만 써서 정규식에 그대로 넣을 수 있습니다.
export const AUTH_ROUTE_SEGMENT = 'auth';
export const SIGN_IN_SEGMENT = 'signin';
export const TENANT_SELECTION_SEGMENT = 'tenant-selection';
export const RESET_PASSWORD_SEGMENT = 'reset-password';
export const NEW_PASSWORD_SEGMENT = 'new-password';
export const PASSWORD_CHANGE_COMPLETE_SEGMENT = 'password-change-complete';
export const SEND_VERIFICATION_CODE_SEGMENT = 'send-verification-code';
export const VERIFICATION_EMAIL_SEGMENT = 'verification-email';
export const SIGN_UP_SEGMENT = 'signup';
export const SIGN_UP_FORM_SEGMENT = 'form';
export const VERIFY_EMAIL_SEGMENT = 'verify-email';
export const VERIFY_EMAIL_EXPIRED_SEGMENT = 'verify-email-expired';
export const APPROVAL_WAITING_SEGMENT = 'approval-waiting';
export const PREVIEW_REQUEST_SEGMENT = 'preview-request';
export const SERVICE_PREPARATION_NOTICE_SEGMENT = 'service-preparation-notice';
export const ONBOARDING_SEGMENT = 'onboarding';
export const OFFBOARDING_SEGMENT = 'offboarding';
export const QR_SIGN_UP_SEGMENT = 'qr';
export const QR_SIGN_UP_FORM_SEGMENT = 'form';
export const QR_SIGN_UP_COMPLETE_SEGMENT = 'complete';
export const QR_SIGN_UP_FAILED_SEGMENT = 'failed';
export const LOGOUT_SEGMENT = 'logout';

export const AUTH_ROUTE_PATH = `/${AUTH_ROUTE_SEGMENT}` as const;
export const SIGN_IN_PATH = `${AUTH_ROUTE_PATH}/${SIGN_IN_SEGMENT}` as const;
export const TENANT_SELECTION_PATH =
  `${AUTH_ROUTE_PATH}/${TENANT_SELECTION_SEGMENT}` as const;
export const RESET_PASSWORD_PATH =
  `${AUTH_ROUTE_PATH}/${RESET_PASSWORD_SEGMENT}` as const;
export const NEW_PASSWORD_PATH =
  `${AUTH_ROUTE_PATH}/${NEW_PASSWORD_SEGMENT}` as const;
export const PASSWORD_CHANGE_COMPLETE_PATH =
  `${AUTH_ROUTE_PATH}/${PASSWORD_CHANGE_COMPLETE_SEGMENT}` as const;
export const PREVIEW_REQUEST_PATH =
  `${AUTH_ROUTE_PATH}/${PREVIEW_REQUEST_SEGMENT}` as const;
export const OFFBOARDING_PATH =
  `${AUTH_ROUTE_PATH}/${OFFBOARDING_SEGMENT}` as const;

export const SIGN_UP_PATH = `${AUTH_ROUTE_PATH}/${SIGN_UP_SEGMENT}` as const;
export const SIGN_UP_FORM_PATH =
  `${SIGN_UP_PATH}/${SIGN_UP_FORM_SEGMENT}` as const;
export const VERIFY_EMAIL_PATH =
  `${SIGN_UP_PATH}/${VERIFY_EMAIL_SEGMENT}` as const;
export const VERIFY_EMAIL_EXPIRED_PATH =
  `${SIGN_UP_PATH}/${VERIFY_EMAIL_EXPIRED_SEGMENT}` as const;
export const APPROVAL_WAITING_PATH =
  `${SIGN_UP_PATH}/${APPROVAL_WAITING_SEGMENT}` as const;

export const QR_SIGN_UP_PATH = `${SIGN_UP_PATH}/${QR_SIGN_UP_SEGMENT}` as const;
export const QR_SIGN_UP_FORM_PATH =
  `${QR_SIGN_UP_PATH}/${QR_SIGN_UP_FORM_SEGMENT}` as const;
export const QR_SIGN_UP_COMPLETE_PATH =
  `${QR_SIGN_UP_PATH}/${QR_SIGN_UP_COMPLETE_SEGMENT}` as const;
export const QR_SIGN_UP_FAILED_PATH =
  `${QR_SIGN_UP_PATH}/${QR_SIGN_UP_FAILED_SEGMENT}` as const;
